// @flow strict

import React from 'react';

import { SvgIcon, type SvgIconComponentProps } from './svg-icon';

/**
 * Icon for newsletter.
 *
 * @param {SvgIconComponentProps} props - component props
 *
 * @returns {Node}
 */
export const NewsletterIcon = (props: SvgIconComponentProps) => {
  const style = `svg:hover .hover { fill: #FF6600; } svg:hover .hover-stroke { stroke: #FF6600 }`;

  return (
    <SvgIcon viewBox="0 0 67 67" name="OMQNewsletterIcon" {...props}>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <g fill="none" fillRule="evenodd">
        <circle
          cx="33.206"
          cy="33.12"
          r="33.12"
          fill="#D8D8D8"
          className="hover"
        />
        <path
          fill="#2D2B2B"
          d="M37.499 46.227c-.234 0-.459-.132-.564-.357-.149-.312-.015-.686.295-.832.318-.154.711-.025.858.285.146.313.036.674-.274.821l-.046.022c-.088.042-.179.061-.269.061"
        />
        <path
          className="hover"
          fill="#D8D8D8"
          d="M52.214 30.488h-.074l-15.103 11.83-1.883-1.307c-1.007-.69-2.312-.69-3.32 0l-1.92 1.325-15.14-11.848 4.345-2.264H47.87l4.344 2.264z"
        />
        <path
          fill="#FFF"
          stroke="#FFF"
          d="M15.623 30.76L29.92 41.802l1.624-1.107c1.181-.799 2.715-.803 3.9 0l1.59 1.088L51.32 30.736l-3.517-1.81h-28.62l-3.561 1.833zM29.9 42.911c-.11 0-.217-.035-.31-.105l-15.2-11.74c-.133-.104-.205-.269-.19-.435.016-.169.116-.318.269-.395l4.36-2.245c.071-.037.152-.056.232-.056h28.866c.08 0 .161.02.232.056l4.36 2.245c.206.104.312.335.257.557-.047.184-.192.321-.372.364L37.36 42.79c-.172.134-.415.141-.595.016l-1.89-1.295c-.843-.567-1.928-.565-2.763.002l-1.928 1.312c-.086.058-.184.087-.284.087h0z"
        />
        <path
          fill="#FFF"
          d="M22.262 13.824c-.85 0-1.556.71-1.556 1.586v30.382h-1.612V15.41c0-.877.688-1.586 1.557-1.586h1.611z"
        />
        <path
          fill="#FFF"
          d="M47.894 20.915v24.877h-27.9V15.41c0-.877.75-1.586 1.652-1.586h18.952l7.296 7.091z"
        />
        <path
          fill="#FFF"
          d="M19.8 45.9h27.9V21.322L40.865 14.4H20.9c-.606 0-1.1.5-1.1 1.114V45.9zm28.301.9H19.4c-.275 0-.499-.227-.499-.505V15.616c0-1.167.937-2.116 2.09-2.116h20.032c.133 0 .26.053.353.148l7.079 7.17c.093.094.146.222.146.356v25.121c0 .278-.224.505-.499.505z"
        />
        <path
          className="hover"
          fill="#D8D8D8"
          d="M42.176 15.018l-1.194-1.194v5.59c0 .89.72 1.61 1.611 1.61h5.589l-6.006-6.006z"
        />
        <path
          fill="#FFF"
          d="M43.862 21.024h-1.237c-.908 0-1.643-.72-1.643-1.61v-5.59l1.218 1.194v4.396c0 .89.754 1.61 1.662 1.61"
        />
        <path
          fill="#FFF"
          d="M41.4 15.3v4.303c0 .604.493 1.097 1.097 1.097H46.8l-5.4-5.4zm1.863 6.3c-1.028 0-1.863-.835-1.863-1.863v-4.892c0-.18.108-.342.274-.411.167-.07.358-.03.485.097l6.31 6.31c.127.127.166.318.098.485-.07.166-.231.274-.412.274h-4.892z"
        />
        <path className="hover" fill="#D8D8D8" d="M32 7H42V9H32z" />
        <path
          className="hover hover-stroke"
          fill="#D8D8D8"
          stroke="#D8D8D8"
          d="M34.72 20.6h-9.65c-.277 0-.504-.194-.504-.432s.227-.432.504-.432h9.65c.276 0 .502.194.502.432s-.226.432-.503.432M37.315 24.344h-12.25c-.274 0-.499-.194-.499-.432s.225-.432.5-.432h12.25c.274 0 .498.194.498.432s-.224.432-.499.432M41.92 28.088H25.07c-.277 0-.503-.194-.503-.432s.226-.432.503-.432H41.92c.277 0 .502.194.502.432s-.225.432-.502.432M41.92 31.832H25.07c-.277 0-.503-.194-.503-.432s.226-.432.503-.432H41.92c.277 0 .502.194.502.432s-.225.432-.502.432"
        />
        <path
          className="hover"
          fill="#D8D8D8"
          d="M30.038 42.428l-14.55 9.988c-.432-.375-.714-.918-.714-1.537V30.528l15.264 11.9z"
        />
        <path
          fill="#FFF"
          stroke="#FFF"
          d="M15.197 31.762v19.205c0 .316.097.616.28.871l13.508-9.298-13.788-10.778zm.208 21.23c-.117 0-.234-.04-.327-.123-.56-.485-.88-1.177-.88-1.902V30.739c0-.191.11-.365.281-.449.17-.081.377-.064.527.055l15.129 11.826c.125.1.195.25.191.41-.006.158-.086.306-.216.396l-14.422 9.927c-.086.059-.183.088-.283.088h0z"
        />
        <path
          className="hover"
          fill="#D8D8D8"
          d="M52.214 30.528v20.351c0 .619-.28 1.162-.712 1.537L36.95 42.409l15.19-11.881h.074z"
        />
        <path
          fill="#FFF"
          stroke="#FFF"
          d="M38.001 42.516l13.513 9.321c.183-.255.28-.556.28-.872V31.693L38.001 42.516zm13.303 10.388l-14.425-9.95c-.13-.09-.21-.239-.216-.397-.004-.16.066-.31.19-.41l15.058-11.815c.307-.234.88.008.88.394v20.24c0 .725-.32 1.417-.878 1.903-.093.082-.21.123-.327.123-.1 0-.196-.03-.282-.088z"
        />
        <path
          className="hover"
          fill="#D8D8D8"
          d="M51.638 52.502c-.354.302-.8.49-1.304.49H16.943c-.503 0-.95-.188-1.305-.49l14.423-10.035 1.919-1.337c1.006-.696 2.31-.696 3.317 0l1.882 1.319 14.46 10.053z"
        />
        <path
          fill="#FFF"
          stroke="#FFF"
          d="M16.528 52.241c.113.028.229.041.346.041h33.529c.117 0 .233-.013.346-.04L35.018 41.457c-.842-.571-1.927-.57-2.761.002L16.527 52.24zm33.875 1.039H16.874c-.597 0-1.161-.209-1.633-.602-.12-.1-.186-.25-.178-.406.008-.155.088-.3.217-.387l16.41-11.248c1.18-.805 2.713-.809 3.898 0l1.891 1.306 14.517 9.942c.13.087.21.232.218.387.008.154-.059.306-.178.406-.472.393-1.036.602-1.633.602h0z"
        />
        <path
          fill="#FBB040"
          d="M54.122 63.391L6.109 63.391M61.169 63.391L56.863 63.391"
        />
        <path
          fill="#FFF"
          d="M13.656 24.084c-.898.457-1.413.972-1.87 1.87-.19.375-.717.375-.908 0-.457-.898-.972-1.413-1.87-1.87-.375-.191-.375-.718 0-.908.898-.458 1.413-.973 1.87-1.87.19-.376.717-.376.908 0 .457.897.972 1.412 1.87 1.87.375.19.375.717 0 .908M59.875 25.689c-.609.31-.958.659-1.268 1.267-.129.254-.486.254-.615 0-.31-.608-.659-.957-1.267-1.267-.254-.13-.254-.486 0-.615.608-.31.957-.659 1.267-1.268.13-.253.486-.253.615 0 .31.61.659.958 1.268 1.268.254.129.254.486 0 .615"
        />
        <path
          fill="#FFF"
          d="M44 15H45V22H44z"
          transform="rotate(-45 44.5 18.5)"
        />
      </g>
    </SvgIcon>
  );
};
